<template>
    <div>
       
                <!-- Диалог ввода наличных оплат -->
                
                <q-modal v-model="addCashForm" content-css="padding: 10px;" no-backdrop-dismiss>
                    <form action="#" id='addCashForm' @submit.prevent='okAddCashDialog'>
                        <div class="q-title q-pa-md text-grey-8 uppercase">
                            приход наличными
                        </div>
                        <div class='q-pa-md q-mb-lg'>
                            <div class="q-mb-sm text-grey-6">Сумма прихода:</div>
                            <div>
                                <q-input placeholder='100' v-model='cashParams.cash' suffix='р.' autofocus type="number"/>
                            </div>

                            <div class="q-mb-sm q-mt-lg text-grey-6">Дата оплаты:</div>
                            <div>
                                <q-datetime v-model="cashParams.cash_at" type="date"  format="DD MMMM YYYY (dddd)"/>
                            </div>
                            <div class="q-mb-sm q-mt-lg text-grey-6">Комментарии (необязательно):</div>
                            <div>
                                <q-input placeholder='' v-model='cashParams.comment' />
                            </div>

                        </div>
                        <div class="row no-wrap justify-end q-ma-sm">
                            <q-btn label='отмена' color='negative'  flat class="q-mr-md" @click='cancelAddCashDialog'/>
                            <q-btn label='ok' color='positive' style='width:100px;' type='submit'/>
                        </div>
                    </form>
                </q-modal>

                <!-- Основное диалоговое окно -->
                <form id="billEditForm" action="#"  @submit.prevent="saveBill">
                <q-modal v-model="billEditForm"  no-backdrop-dismiss content-css="width:1000px; height:100%">
                        <q-modal-layout>
                            <q-toolbar slot="header">
                                <q-toolbar-title>
                                    Оплата 
                                </q-toolbar-title>

                                <q-btn
                                    color="negative"
                                    label="Отмена"
                                    icon = "cancel"
                                    wait-for-ripple
                                    @click="cancel"
                                    style="margin-right: 20px; width:150px"
                                    :loading='isLoading'
                                />
                                
                                <q-btn
                                    color="green"
                                    label="Сохранить"
                                    icon = "save"
                                    wait-for-ripple
                                    :loading="isLoading"
                                    style="width:150px"
                                    @click = 'saveBill'
                                    :disable="isCheckError"
                                />
                            </q-toolbar>

<!-- Низкое разрешение! -->
                            <div class='lt-sm'>
                                <div class='mobile-only orientation-portrait absolute-center'>
                                    <p><strong>Внимание!</strong></p> Низкое разрешение, поверните устройство в горизонтальную ориентацию!
                                </div>
                                <div class='desktop-only absolute-center'>
                                     <p><strong>Внимание! </strong></p>Низкое разрешение, функционал ограничен!
                                </div>
                            </div>
 <!-- приемлемое разрешени -->
                            <div class='gt-xs'>
                                        <!-- Выводим файлы -->
                                        <div v-if='isFileVisible' class='q-pa-lg'>
                                            <div v-for='item in billFiles' :key=item.id>
                                                <bill-dialog-file 
                                                    :order='item'
                                                />
                                            </div>
                                        </div>
                                        <div v-if='!isFileVisible' class='fullscreen'>
                                            <q-spinner-ball  :size="100"  color="primary" class="absolute-center"/>
                                        </div>
                                            
                                        <!-- Блок итоговой стоимости -->
                                        <div class='row q-ma-lg myBorder shadow-5 bg-grey-2' v-if='isFileVisible'>
                                            <div class='row no-wrap bg-green-7 text-white full-width q-pa-md q-title uppercase justify-between items-baseline'>
                                                <div>Параметры оплаты</div>
                                                <div>Итого:  <span class='q-headline'>{{getAllCost}} р.</span></div>
                                            </div>
                                            <div class='row no-wrap q-pa-lg full-width'>
                                                <div class="col-4 q-ma-md">
                                                    <span class='text-grey-7 lowercase q-caption'>Юридическое лицо</span>
                                                    <q-select 
                                                        v-model ='params.billParam.org'
                                                        :options = 'organizationList'
                                                        placeholder = 'Юридическое лицо'
                                                        class='full-width'
                                                    />
                                                </div>
                                                <div class="col-2 q-ma-md">
                                                    <span class='text-grey-7 lowercase q-caption'>Номер счета</span>
                                                    <q-input 
                                                        v-model ='params.billParam.number'
                                                        placeholder="Номер счета"
                                                        @input='checkCountDown'
                                                        :error="isCheckError"
                                                    />
                                                    <div v-if='isCheck' class='q-caption text-grey-7 q-mt-xs'>
                                                        Проверка через {{timeToCheck}} сек
                                                    </div>
                                                    <div v-if='isCheckError' class='q-caption text-red q-mt-xs'>
                                                        Привязка к этому счету уже существует
                                                    </div>
                                                </div>
                                                <div class="col-6 q-ma-md">
                                                    <span class='text-grey-7 lowercase q-caption'>Дата</span>
                                                    <q-datetime 
                                                        v-model="params.billParam.bill_at" 
                                                        minimal
                                                        type="date" 
                                                        style='width:80%'
                                                        format="DD.MM.YYYY"
                                                    />
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                        <!-- Блок оплат -->
                                        <div class='row q-ma-lg myBorder shadow-5 bg-grey-2' v-if='isFileVisible'>
                                            <!-- Левый столбец с безналичнымы оплатами -->
                                                <div class="col-6 q-pa-md">
                                                    <div class="row full-width bg-deep-orange-12 q-pa-md text-white uppercase q-subheading justify-between items-center">
                                                        <span class='q-ml-xs'>безналичные оплаты : {{summaOfBeznal}} р.</span>
                                                    </div>
                                                    <div class="myBorder full-width">
                                                        <div v-if='!isBeznal' class='q-pa-md text-center'>Безналичных оплат не найдено</div> 
                                                        <!-- Если есть наличные приходы - то выводим их список -->
                                                        <div v-if='isBeznal' class='q-pa-xs'>
                                                            <div v-for="beznal in beznalPrihod" :key='beznal.id'>
                                                            <div class="row no-wrap full-width myBorder q-mb-xs q-pa-sm q-caption items-center ellipsis bg-grey-2">
                                                                    <div class='q-ml-sm col-3'>{{getPrettyDate(beznal.pay_at)}}</div>
                                                                    <div class='q-ml-sm col-3'>{{beznal.pay_value}}</div>
                                                                    <div class='q-ml-sm col-6'>
                                                                        <span v-if='beznal.comment==null' class='text-grey-8 text-italic'>No comment</span>
                                                                        {{beznal.comment}}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>                                
                                                </div>
                                            <!-- правый столбец с наличными оплатами -->
                                                <div class="col-6 q-pa-md">
                                                    <div class="row full-width bg-blue-6 q-pa-sm text-white uppercase q-subheading justify-between items-center">
                                                        <span class='q-ml-xs'>Наличные оплаты : {{summaOfNal}} р.</span>
                                                        <q-btn round dense flat icon='far fa-plus-square' size='md' @click='showAddCashDialog'/>
                                                    </div>
                                                    <div class="myBorder full-width">
                                                        <div v-if='!isNal' class='q-pa-md text-center'>Наличных оплат не найдено</div>
                                                        <!-- Если есть наличные приходы - то выводим их список -->
                                                        <div v-if='isNal' class='q-pa-xs'>
                                                            <div v-for='item in nalPrihod' :key=item.id class='mySelect'>
                                                                <div class="row no-wrap full-width myBorder q-mb-xs q-caption items-center ellipsis" v-bind:class="{ 'bg-red-2 q-pa-xs': isDel(item),'bg-grey-2': !isDel(item)}">
                                                                    <q-btn icon='far fa-trash-alt' class='q-ml-xs' flat dense  color='primary' @click='deleteMark(item.id)' v-if='!isDel(item)'/>
                                                                    <q-icon name='cancel' v-if='isDel(item)' color='red'/>
                                                                    <div class='q-ml-sm'>
                                                                        {{getPrettyDate(item.cash_at)}}
                                                                    </div>
                                                                    <div class='q-ml-md'>
                                                                        {{item.cash}} р.
                                                                    </div>
                                                                    <div class='q-ml-md ellipsis'>
                                                                        <span v-if='isComment(item)'>{{item.comment}}</span>
                                                                        <span v-if='!isComment(item)' class='text-grey-8 text-italic'>No comments</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                            </div>
                        </q-modal-layout>
                </q-modal>
                </form>        
     
    </div>

</template>

<script>
/* eslint-disable */
export default {
    
    name : 'billEditForm',
    
    data() {
        return {
            addCashForm : false,
            billEditForm : false,
            isFileVisible : false,
            isLoading : false,
            isCheck : false,
            isCheckError : false,
            timeToCheck : 5,
            timerId : null,
            params : {
                billParam : {
                    org : 0,
                    number : null,
                    bill_at : new Date(),
                },
                selectedOrders : [],
            },
            cashParams : {
                billId : null,
                cash : '',
                cash_at : new Date(),
                comment : '',
            }
        }
    },
    
    components : {
        billDialogFile : () => import('./billDialogFile.vue'),
    },

    created() {

        eventBus.$on('openBillDialog', (order) => {
            this.isFileVisible = false; // скрываем файлы
            this.billEditForm = true;

            this.isCheckError = false;
            this.emptyFields(); // очищаем параметры
            
            this.$store.commit('clearBillData'); //Очищаем данные наличных и безналичных оплат

            // получаем рабочие файлы - в этот момент неплохо бы выводить спинер ожидания - но да ладно
            if (order === undefined) {
                console.log('order undefined');
                this.$store.dispatch('retrieveBillFiles')
                .then(()=>{
                    this.isFileVisible = true; //показываем файлы
                    console.log('показываем файлы')
                })
                .catch(()=>{});
            } else { // если номер заказа существует - то: блокируем заказы с таким же счетом
                this.$store.dispatch('lockBillLinkOrders', order) 
                .then(() => { // если удачно заблокировали
                    
                    // Загружаем прайс лист клиента!
                    let contragent = this.$store.getters.getContragentById(order.contragent);
                    this.$store.dispatch("getPriceById", contragent.priceId)
                    .then(()=>{
                        // this.$q.loading.hide();
                        // this.editOrder = true;
                    })
                    .catch(()=>{
                        // this.$q.loading.hide();
                        // this.editOrder = true;
                    }); //загружаем прайс лист текущего клиента

                    this.$store.dispatch('retrieveBillFiles') // при блокировке заполняется массив выделенных файлов
                    .then(()=>{
                        this.isFileVisible = true; //показываем файлы
                        let bill = this.$store.getters.getBillData;
                        this.cashParams.billId = bill.id; //сохраняем номер редактируемого ID-счета
                        if (bill != undefined) {
                            this.params.billParam = bill;

// загружаем все приходы ----------------------------------------------------------------------------------------------------------------
                            this.$store.dispatch('getCommings');
                            
                        }
                    })
                    .catch(()=>{});
                })
                .catch(error=>{ //неудачная блокировка заказов связанных заказов
                    console.log(error);
                    this.$admns.showNotify('Не узалось заблокировать заказы','error','Сообщение системы');
                    this.cancel(); // отмена показа диалогового окна
                });
            } // else

        });

        // проверяем загрузку списка организаций
        let q = this.$store.getters.getAllOrganization;
        if (q.length==0) { //значит возможно список организаций не загружен - то загружаем
            this.$store.dispatch('getOrganization')
            .then()
            .catch();
        }

    },

    beforeDestroy() {
        eventBus.$off('openBillDialog');
    },

    computed : {
        summaOfBeznal() {

            let beznalList = this.$store.getters.getBeznal;
            var result = 0;
            
            if (beznalList == undefined) return result;

            beznalList.forEach(element => {
                result += element.pay_value*1;
            });
            return result;

        },

        summaOfNal(){
            let nalList = this.$store.getters.getNal;
            var result = 0;
            nalList.forEach(element => {
                if ((element.deleteFlag==0)||(element.deleteFlag == undefined)) result += element.cash*1;
            });
            return result;
        },

        isBeznal() {
            return this.$store.getters.getBeznal != undefined ? this.$store.getters.getBeznal.length > 0 : false;
        },

        isNal() {
            return this.$store.getters != undefined ? this.$store.getters.getNal.length > 0 : false;
        },

        beznalPrihod() {
            return this.$store.getters.getBeznal;
        },

        nalPrihod(){
            return this.$store.getters.getNal;
        },

        nalItog(){
            let nal = this.$store.getters.getNal;
            var result = 0;
            if (nal == undefined) return result;
            nal.forEach(element => {
                result += element.cash;
            });
            return result;
        },

        billFiles() {
            return this.$store.getters.getOrderFiles; // Получаем файло
        },

        getAllCost() {
            return  this.$store.getters.getAllCost;
        },

        organizationList() {
            var list = [];
            if (this.$store.getters.getAllOrganization == undefined) return list;
            this.$store.getters.getAllOrganization.map((value,key)=>{
                list.push({label:value.name, value:value.id});
            });
            return list;
        }

    },

    methods : {

        timerFunct() {

            this.timeToCheck -= 1;
            if ((this.timeToCheck > 0)&&(this.isCheck)) {
                this.timerId = setTimeout(this.timerFunct, 1000);
            } else { //тогда проверяем

                if (this.isCheck) {             

                    this.isCheck = false;
                    this.$store.dispatch('checkBillNumber', this.params.billParam)
                    .then((data)=>{
                        console.log(data);
                        if (data.length>0) { // значит все плохо - пишем ошибку
                            this.isCheckError = true;
                        }
                    })
                    .catch();

                }
            }
        },

        checkCountDown(newValue) {
            this.isCheckError = false;
            if (newValue > '') {
                this.isCheck = true;
                this.timeToCheck = 3;
                clearTimeout(this.timerId);
                this.timerId = setTimeout(this.timerFunct, 1000);
            }
        },

        isComment(item) {
            if ((item.comment=='')||(item.comment==null)) return false;
            return true;
        },

        isDel(item) {
            return item.deleteFlag===1;
        },

        deleteMark(nalId) {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Пометить на удаление этот приход?',
                color: 'primary',
                ok : 'Да',
                cancel : 'Отмена',
                preventClose : false,
            })
            .then(()=>{
                this.$store.dispatch('deleteMarkNal', nalId)
                .then()
                .catch();
            })
            .catch();
            
        },

        getPrettyDate(d) {
            let result = new Date(d);
            if (result == undefined) return '';
            return result.toLocaleDateString('ru');
        },

        hideCashDialogData() { // очищаем диалог и закрываем окно
            delete this.cashParams.billId;
            this.cashParams.cash=null;
            this.cashParams.cash_at = new Date();
            this.cashParams.comment = '';

            this.addCashForm = false;
        },

        cancelAddCashDialog(){
            this.hideCashDialogData();
        },

        okAddCashDialog() {
            if ((this.cashParams.cash==null)||(this.cashParams.cash=='')) { 
                this.$admns.showNotify('Необходимо ввести приход','error','проверка вводимых данных');
                return;
            }
            if (this.cashParams.cash<0) {
                this.$admns.showNotify('Значение не может быть отрицательным','error','проверка вводимых данных');
                return;
            }

// надо проверить на нулевой 

            this.$store.dispatch('saveNal', this.cashParams)
            .then(()=>{
                this.hideCashDialogData();
            })
            .catch(error => {
                console.log(error);
            });           
        },

        showAddCashDialog(){
            this.addCashForm = true;
        },

        emptyFields() {
            delete this.params.billParam.id;
            this.params.billParam.org = 0;
            this.params.billParam.number = null;
            this.params.billParam.bill_at = new Date();
            },

        unlockOrders(){ //разблокирует записи
            this.$store.dispatch('unlockOrders', this.$store.getters.getSelectedOrders)
            .then(()=>{
                this.$store.commit('clearSelectedOrders');
            })
            .catch();

        },

        saveBill() {
            
            this.isLoading = true;
            // console.log(this.params);
            // return;
            this.$store.dispatch('checkBillNumber', this.params.billParam) // проверяем номер счета
            .then((data)=>{

                if (data.length>0) { // значит все плохо - пишем ошибку
                    
                    this.isCheckError = true;
                    this.isLoading = false;

                } else { // все хорошо - сохраняемся

                        this.isLoading = true;
                        this.params.selectedOrders = this.$store.getters.getSelectedOrders; // сохраняем отмеченные заказы для формирования запроса
                        // return;
                        this.isCheck = false; // чтобы больше не запрашивалась проверка

                        // берем номер счета для клиента из параметров заказа
                        let q1 = this.$store.getters.getOrderById(this.params.selectedOrders[0]); // из первого отмеченного
                        this.params.billParam.id = q1.bill_out;

                        this.$store.dispatch('saveBill', this.params)
                        .then(()=>{
                            this.billEditForm =false;
                            this.isFileVisible = false; //скрываем файлы
                            this.emptyFields();
                            this.isLoading  = false;
                            this.$store.commit('clearSelectedOrders');
                        })
                        .catch((error)=>{
                            this.isLoading = false;
                        });
                }
            })
            .catch((error)=> {
                 this.isLoading = false;
            });



        },

        cancel() {
            this.billEditForm =false;
            this.emptyFields();
            this.unlockOrders();
            // this.$store.commit('clearSelectedOrders');
            // this.isFileVisible = false; //скрываем файлы+
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .myBorder {
        border : 1px solid rgb(194, 194, 194);
    }
    .mySelect {
        
        &:hover {
                background: green;
        }
    }
</style>
